import __vue_component__ from './Blanket.vue.js';
import __vue_component__$1 from './PositionerAbsolute.vue.js';
import __vue_component__$2 from './Header.vue.js';
import __vue_component__$3 from './Footer.vue.js';

//
const ESC = 27;
var script = {
  name: 'Modal',
  components: {
    Blanket: __vue_component__,
    PositionerAbsolute: __vue_component__$1,
    Header: __vue_component__$2,
    Footer: __vue_component__$3
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    appearance: {
      type: String,
      default: undefined
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => ['Continue', 'Cancel']
    },
    pending: {
      type: Boolean,
      default: false
    },
    shouldAllowSubmit: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '600px'
    },
    zIndex: {
      type: Number,
      default: 999
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      mounted: false
    };
  },

  beforeMount() {
    document.addEventListener('keyup', this.onEsc);
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.onEsc);
  },

  methods: {
    onEsc(e) {
      if (e.keyCode === ESC && this.closeOnEsc && !this.pending) {
        this.$emit('cancel');
      }
    },

    onCancel() {
      this.$emit('cancel');
    },

    onSubmit() {
      this.$emit('submit');
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Modal/Modal.vue_rollup-plugin-vue=script.js